export class InstantError extends Error {
    constructor(message, hint) {
        super(message);
        this.hint = hint;
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            Object.setPrototypeOf(this, actualProto);
        }
        // Maintain proper stack trace for where our error was thrown
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InstantError);
        }
        this.name = 'InstantError';
    }
    get [Symbol.toStringTag]() {
        return 'InstantError';
    }
}
//# sourceMappingURL=InstantError.js.map